<template>
    <dtg-layout-base :class="b()" :loading="loading">
        <template #before-inner-content>
            <slot name="before-content" />
        </template>
        <template #content>
            <slot />
        </template>
        <template #after-inner-content>
            <slot name="after-content" />
        </template>
    </dtg-layout-base>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { getName, useBem } from 'dtg-components';

import { DtgLayoutBase } from '@/components/layouts/layout-base';

import styles from './style.module.scss';

export default defineComponent({
    name: getName(styles),

    components: {
        DtgLayoutBase,
    },

    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },

    setup() {
        return {
            b: useBem(styles),
        };
    },
});
</script>

